import RecordItem from '@/pages/clueManage/clueDetail/components/FollowUp/RecordItem'
import { getCustomerFollowRecord } from '@/services/customerManage'
import { salesWorkPage } from '@/services/saleOpServices'
import { Empty, message, Select, Skeleton, Timeline } from 'antd'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'

const FollowRecord = () => {
  const { id } = useParams()
  const [logList, setLogList] = useState<any[]>([])
  const [clueList, setClueList] = useState<any[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [selectLoading, setSelectLoading] = useState<boolean>(false)
  const [selectedClue, setSelectedClue] = useState<string>('')

  // 获取线索列表
  const getClueList = useCallback(() => {
    try {
      setSelectLoading(true)
      salesWorkPage({
        params: { pageId: 1, pageSize: 30 },
        data: { customerId: id, filterStatusFlag: false },
      })
        .then((res: any) => {
          const clueList = res.list.map((item: any) => ({
            label: item.id,
            value: item.id,
          }))
          setClueList(clueList)
          setSelectedClue(clueList[0].value)
        })
        .finally(() => {
          setSelectLoading(false)
        })
    } catch (error) {
      message.error('获取线索列表失败')
    }
  }, [id])

  // 获取跟进记录数据
  const getFollowUpRecord = useCallback(() => {
    try {
      if (!selectedClue) return
      setLoading(true)
      getCustomerFollowRecord({ clueId: selectedClue })
        .then((res: any) => {
          setLogList(res)
        })
        .finally(() => {
          setLoading(false)
        })
    } catch (error) {
      message.error('获取跟进记录失败')
    }
  }, [selectedClue])

  // 跟进记录列表
  const items = useMemo(() => {
    return logList.map(item => ({
      key: item.id,
      children: <RecordItem key={item.id} item={item} />,
    }))
  }, [logList])

  useEffect(() => {
    getFollowUpRecord()
  }, [getFollowUpRecord])

  useEffect(() => {
    getClueList()
  }, [getClueList])

  return (
    <div style={{ backgroundColor: '#fff', padding: '20px 15px 0', flex: 1 }}>
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <span style={{ fontSize: 16, fontWeight: 600 }}>跟进记录</span>
        <Select
          options={clueList}
          style={{ width: 200 }}
          onChange={setSelectedClue}
          value={selectedClue}
          loading={selectLoading}
        />
      </div>
      <div style={{ height: 'calc(100vh - 230px)', overflow: 'auto', marginTop: 15 }}>
        <Skeleton active loading={loading}>
          {items?.length ? (
            <Timeline items={items} />
          ) : (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          )}
        </Skeleton>
      </div>
    </div>
  )
}

export default React.memo(FollowRecord)
